import router from './router'
// import store from './store'
// import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
// import 'nprogress/nprogress.css' // progress bar style
// import { getToken } from '@/utils/auth' // get token from cookie
// import getPageTitle from '@/utils/get-page-title'
// import websocket from '@/utils/websocket'
import defaultSettings from '@/settings'

const title = defaultSettings.title || ''

function getPageTitle(pageTitle) {
  return pageTitle || title
}


NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login'] // no redirect whitelist

router.beforeEach(async(to, from, next) => {
    // start progress bar
    NProgress.start()

    // set page title
    document.title = getPageTitle(to.meta.title)

    next();
    // ////暂不需要权限
    // // determine whether the user has logged in
    // var hasToken = getToken()
    // if(!hasToken) {
    //     try {
    //         let res = await store.dispatch('user/loginByBrowserId');
    //         if (res && res.token) {
    //             hasToken = res.token;
    //         }
    //     } catch (error) {
    //         //console.log(error);
    //     }
    // }
    // if (hasToken) {
    //     websocket.init();
    //     if (to.path && to.path.indexOf('/login') === 0) {
    //         // if is logged in, redirect to the home page
    //         let url;
    //         if (to.query.redirect) {
    //             url = decodeURIComponent(to.query.redirect);
    //         } else {
    //             url = '/';
    //         }
    //         next({ path: url });
    //         NProgress.done()
    //     } else {
    //         const hasPermission = store.getters.permission && store.getters.permission.length > 0
    //         if (hasPermission) {
    //             next()
    //         } else {
    //             try {
    //                 // get user info
    //                 await store.dispatch('user/getUserPermissionCurrent')

    //                 // generate accessible routes map based on roles
    //                 const accessRoutes = await store.dispatch('permission/generateRoutes', store.getters.permission)

    //                 //console.log("获取路由：",accessRoutes);
    //                 // dynamically add accessible routes
    //                 router.addRoutes(accessRoutes)
    //                 next({...to, replace: true })
    //             } catch (error) {
    //                 // remove token and go to login page to re-login
    //                 await store.dispatch('user/resetToken')
    //                 Message.error(error || 'Has Error')
    //                 console.log(error, "验证权限出错了，跳转到登录:", to.path)
    //                 let url = encodeURIComponent(to.fullPath);
    //                 next(`/login?redirect=${url}`)
    //                 NProgress.done()
    //             }
    //         }
    //     }
    // } else {
    //     websocket.close();
    //     /* has no token*/
    //     if (whiteList.indexOf(to.path) !== -1) {
    //         // in the free login whitelist, go directly
    //         next()
    //     } else {
    //         // other pages that do not have permission to access are redirected to the login page.
    //         let url = encodeURIComponent(to.fullPath);
    //         next(`/login?redirect=${url}`)
    //         NProgress.done()
    //     }
    // }
})

router.afterEach(() => {
    // finish progress bar
    NProgress.done()
})
